export default __webpack_public_path__ + "static/media/sd_card.432a9680.svg";